import { Azienda } from 'src/app/Admin/models/Azienda';
import { Progetto } from 'src/app/Progetti/Models/Progetto';
import { Persona } from '../../Admin/models/persona';
import { ClassicType } from '../../shared/models/ClassicType';
import { Files } from 'src/app/shared/models/File';
import { Sede } from 'src/app/Admin/models/Sede';
import { Prodotto } from 'src/app/Progetti/Models/Prodotto';
import {Tempo} from "./tempo";
export class Intervento {
  id?: number;
  id_responsabile?: number;
  manager?: Persona;
  managers?: Persona [];
  data_inizio_prevista?: string;
  data_fine_prevista?: string;
  data_inizio_effettiva?: string;
  data_fine_effettiva?: string;
  nome?: string;
  note?: string;
  stato?: number;
  statoObject?: ClassicType;
  statiObject?: ClassicType [];
  progetto?: number;
  padre?: number;
  tipo?: number;
  tipoObject?: ClassicType;
  tipiObject?: ClassicType [];
  persone?: any[];
  files?: Files[];
  selected?: boolean;
  sedeObject?: Sede;
  progettoObject?: Progetto;
  clienteObject?: Azienda;
  bgcolor?: string;
  difetto?: string;
  prodotti?: Prodotto[];
  figli?: Intervento[];
  tempi?: Tempo[];
  durata?: number;
  todo?: any;
  chiuso?: boolean;
  managerObject?: any;
  speseObject?: any[];
  importo?: number;
  constructor(id?:number, data_fine_prevista?: string, id_responsabile?:number){
    this.todo=[]
    this.id = id;
    this.data_fine_prevista = data_fine_prevista;
    this.id_responsabile = id_responsabile;
    this.tipiObject = [];
    this.statiObject = [{ id:'32', label: "Da fare"}];
    this.managers = [];
  }
}
